var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLogin)?_c('confirm-frame',{attrs:{"order-item-obj":_vm.orderItemObj,"submit-order-item":_vm.submitOrderItem,"protocol":_vm.protocol,"back-url":"#/crs/detail"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }